import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserFullInfoService } from '../services/user-full-info.service';
export const canActivatePermissionsReport: CanActivateFn = async () => {
  const access = inject(UserFullInfoService); const router = inject(Router); const user = await access.loadUserInfo();
  return user?.isAdmin || access.hasPermission('ManageMinisterialActivity', user) ? true : router.createUrlTree(['/']);
};
